import { motion, AnimatePresence } from "framer-motion";
import styled from "@emotion/styled";
import STANDARD_PRICE from "../../data/memberShipPrice";

const StyledDiv = styled.div`
  /* border: 2px solid burlywood; */
  height: fit-content;
  padding: none;
  width: 120px;
  height: 70px;

  font-family: Helvetica, sans-serif;

  .price-text {
    /* border: 2px solid red; */
    font-size: 2rem;
    font-weight: 500;
    margin: none;
    padding: none;
    box-sizing: border-box;
  }
  .price-text-old {
    /* border: 2px solid red; */
    font-size: small;
    font-weight: 500;
    text-decoration: line-through;
  }
`;

const PriceComponent: React.FC<{
  price: number;
  newPrice?: number;
  validCoupon: boolean;
}> = ({ price, newPrice, validCoupon }) => {
  const DISTANCE = 150;
  const Y_OFFSET = 30;
  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 80,
  };

  return (
    <StyledDiv>
      <AnimatePresence mode="wait">
        {validCoupon ? (
          <motion.p
            transition={spring}
            key={newPrice}
            initial={{ y: Y_OFFSET, x: DISTANCE, opacity: 0 }}
            whileHover={{ scale: 1.1 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -DISTANCE, opacity: 0 }}
            className={`price-text`}
          >
            R${newPrice}
          </motion.p>
        ) : (
          <motion.p
            transition={spring}
            key={price}
            initial={{ y: Y_OFFSET, x: DISTANCE, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -DISTANCE, opacity: 0 }}
            className={`price-text`}
          >
            R${price}
          </motion.p>
        )}
        {validCoupon && newPrice != STANDARD_PRICE && (
          <motion.p
            key={`${newPrice}-old-price`}
            className="price-text-old"
            initial={{ y: Y_OFFSET - 60, opacity: 0 }}
            animate={{ opacity: 0.3 }}
          >
            R${price}
          </motion.p>
        )}
      </AnimatePresence>
    </StyledDiv>
  );
};

export default PriceComponent;
